<template>
  <NuxtLink
  :to="$localePath(url)"
  :class="getClasses"
  :target="target"
  :data-cta="isCta ? '' : null"
  :data-cta-label="label"
  >
    <slot /> <span v-if="arrow" aria-hidden="true">→</span>
  </NuxtLink>
</template>

<script setup>
const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: false,
  },
  size: {
    type: String,
    default: 'default'
  },
  arrow: {
    type: Boolean,
    default: false
  },
  index: {
    type: Number,
    default: 1
  },
  target: {
    type: String,
    default: '_self'
  },
  // Optional stable name for analytics. Without it the collector falls back to
  // the button's visible text, which is usually the right label anyway; set it
  // where the text is generic ("Learn more") and you need to tell them apart.
  label: {
    type: String,
    default: null
  }
})

// Only the real button types are CTAs. `data-cta` used to be set
// unconditionally, which made a `type="link"` plain text link (and any Directus
// record with an unset or unrecognised type, of which there are several call
// sites) a conversion action in the permanent CTA dimension.
const CTA_TYPES = ['primary', 'ghost', 'secondary', 'black']
const isCta = computed(() => CTA_TYPES.includes(props.type))

const getClasses = computed(() => {
  let type = props.type || ''
  let classes= ''
  if (type === 'primary') classes += 'rounded-md transition bg-[#5a6ded] border-2 border-[#3645d0] hover:bg-[#3645d0] px-3.5 py-2.5 text-sm font-semibold text-white focus:outline-none'
  if (type === 'ghost' || type === 'secondary') classes += 'rounded-md transition bg-transparent hover:bg-[rgba(0,0,0,0.03)] px-3.5 py-2.5 text-sm font-semibold text-[#5a6ded] focus:outline-none'
  if (type === 'black') classes += 'rounded-md border-2 border-black px-3.5 py-2.5 text-sm font-semibold text-black font-semibold focus:outline-none hover:bg-[rgba(0,0,0,0.03)]'
  return classes
})

</script>